<template>
    <div class="p-3">
        <div class="text-right">
            <button @click.prevent="print" class="btn btn-sm btn-secondary">Печать</button>
        </div>
        <order-print-blank id="printMe" :order="order" :customer="customer"></order-print-blank>
    </div>
</template>
<script>
import OrderPrintBlank from '@/admin/components/OrderPrintBlank.vue';
import { get } from '@/admin/services/api/http-utils';
import api from '@/admin/modules/Customer/api';

export default {
  props: ['orderItemId'],
  components: {
    OrderPrintBlank,
  },
  data() {
    return {
      order: {},
      customer: {
        Tour: {
          Name: null,
        },
      },
      printObj: {
        id: '#printMe',
        popTitle: 'good print',
        // extraCss: 'https://www.google.com,https://www.google.com',
        extraHead: '<meta http-equiv="Content-Language"/>',
      },
    };
  },
  async mounted() {
    await this.fetchOrder();
  },
  watch: {
    async order() {
      if (!_.isEmpty(this.order)) {
        const { data } = await api.fetchCustomer(this.order.CustomerId);
        this.customer = data;
      }
    },
  },
  methods: {
    async fetchOrder() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order/${this.orderItemId}`);
      this.order = data;
      // this.customer = data.customer;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
  },
};
</script>
